import { $lt as __lt, createQueryOperator } from "../../_predicates";
const $lt = createQueryOperator(__lt);
export {
  $lt
};
